import isEqual from 'fast-deep-equal';

import { useAppSelector } from 'hooks/store';
import {
  selectAudienceIsMultiRfm,
  selectAudienceMultiRfmActive,
  selectAudienceMultiRfmGroups,
  selectAudienceMultiRfmIndex,
  selectAudienceMultiRfmOperation,
} from 'store/selectors';

export const useMultiRfm = () => {
  const active = useAppSelector(selectAudienceMultiRfmActive, isEqual);
  const advanced = useAppSelector(selectAudienceIsMultiRfm);
  const groups = useAppSelector(selectAudienceMultiRfmGroups, isEqual);
  const index = useAppSelector(selectAudienceMultiRfmIndex);
  const operation = useAppSelector(selectAudienceMultiRfmOperation);

  return {
    active,
    advanced,
    groups,
    index,
    operation,
    total: groups.length,
  } as const;
};
